//#
// ImageUploadPreview
// Hooks up an image upload field to a div in which to display preview thumbnails
//#

let addPreview;
const ImageUploadPreview =
  //#
  // Set up an event handler for when a file is uploaded.  When a file is
  // uploaded it will create an img tag and display the preview
  // Param {jQuery object} - The file input element
  // Param {jQuery object} - The preview element. This elements content will
  // be replaced with the preview
  (addPreview = ($input, $previewElement) =>
    $input.on('change', function (event) {
      const { files } = event.target;
      const image = files[0];
      const reader = new FileReader();
      reader.onload = function (file) {
        const { result } = file.target;
        if (result.indexOf('application/pdf') >= 0) {
          return $previewElement.html('<h5>PDF Attached.</h5>');
        } else if (
          result.indexOf('video/quicktime') >= 0 ||
          result.indexOf('video/mp4') >= 0
        ) {
          return $previewElement.html('<h5>Video Attached.</h5>');
        } else {
          const img = new Image();
          img.src = file.target.result;
          return $previewElement.html(img);
        }
      };

      return reader.readAsDataURL(image);
    }));

//-----------  EXPORT  -----------#
module.exports = ImageUploadPreview;
window.ImageUploadPreview = ImageUploadPreview;
